import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithGmail_1 from '../../../../../libraries/Images/createAConnectionWithGmail_1.png';
import createAConnectionWithGmail_2 from '../../../../../libraries/Images/createAConnectionWithGmail_2.png';
import createAConnectionWithGmail_3 from '../../../../../libraries/Images/createAConnectionWithGmail_3.png';
import createAConnectionWithGmail_4 from '../../../../../libraries/Images/createAConnectionWithGmail_4.png';
import createAConnectionWithGmail_5 from '../../../../../libraries/Images/createAConnectionWithGmail_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithgmail">
                1.&nbsp;{translate('createaconnectionwithgmail')}
            </Typography>
            <p>Click "Add New" to create the connection.</p>
            <Zoom>
                <img src={createAConnectionWithGmail_1} width="75%" />
            </Zoom>
            <p>A list of applications that can be linked will appear, select "Gmail" from among them.</p>
            <Zoom>
                <img src={createAConnectionWithGmail_2} width="75%" />
            </Zoom>
            <p>When you click "Gmail", the user's Google account selection screen is displayed. Please select an account to use for the connection.</p>
            <Zoom>
                <img src={createAConnectionWithGmail_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>When you select an account, "RPA CLOUD" will request access on your behalf. Agree to grant the above access permission to "RPA CLOUD" and click "Allow".</p>
            <Zoom>
                <img src={createAConnectionWithGmail_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>You will see a Gmail card once the connection is successfully created.</p>
            <Zoom>
                <img src={createAConnectionWithGmail_5} width="50%"/>
            </Zoom>
            <p>Use the <strong>Provider ID</strong> included in this tag to go through the steps in Gmail.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);